export default "/images/vendor/flag-icons/flags/4x3/ni.svg?3f3ca3c75ea86ea71d2866a24a562024";